"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  line-height: 130%;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 11px;\n  height: 11px;\n  border-radius: 999px;\n  margin-right: 8px;\n  border: 0;\n  display: inline-block;\n\n  &.default {\n    background-color: ", ";\n  }\n\n  &.success {\n    background-color: ", ";\n  }\n\n  &.offer-send {\n    background-color: ", ";\n  }\n\n  &.contract-send {\n    background-color: ", ";\n  }\n\n  &.error {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PhaseLabel = function PhaseLabel(_ref) {
  var status = _ref.status,
      text = _ref.text,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["status", "text", "children"]);

  return _react.default.createElement(PhaseLabelWrapper, otherProps, _react.default.createElement(PhaseLabelIndicator, {
    className: status
  }), !children && text ? _react.default.createElement(PhaseLabelText, null, text) : '', children && !text ? children : '');
};

var PhaseLabelWrapper = _styledComponents.default.div(_templateObject());

var PhaseLabelIndicator = _styledComponents.default.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.outline;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.status.succes;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.status.blue;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.status.yellow;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.status.error;
});

var PhaseLabelText = _styledComponents.default.div(_templateObject3(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typo.title;
});

PhaseLabel.defaultProps = {
  status: 'default',
  otherProps: {}
};
PhaseLabel.propTypes = {
  /** The type of the indicator */
  status: _propTypes.string,

  /** The text to be displayed */
  text: _propTypes.string,
  children: _propTypes.node,
  otherProps: _propTypes.object
};
var _default = PhaseLabel;
exports.default = _default;